<template>
  <div class="tab-pane fade" id="month-report" role="tabpanel" aria-labelledby="month-report-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-3">
          <label for="inputEmail4" class="form-label">風景區</label>
          <select class="form-select form-select" v-model.number="selectScenicAreaId">
            <option value="-1">全部</option>
            <option v-for="(list, index) in carFlowScenicArea" :key="index" :value="list.id">{{ list.name }}</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="startTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="endTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryElk()" :disabled="isWaitCCTVList">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="exportMothCSV()" :disabled="isWaitCCTVList"> 
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px;">統計_月報</h1>
      <p>備註 1 ：統計欄位的預估人流為各日預估人流（含負值）總和且四捨五入至整數位。</p>
      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="monthReport" class=" w3-table-all table table-hover table-striped">
                <thead class="table-dark ">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">時間</th>
                    <th scope="col">景區</th>
                    <th scope="col">平假日</th>
                    <th scope="col">機車</th>
                    <th scope="col">小型車</th>
                    <th scope="col">大型車</th>                    
                    <th scope="col">小巴</th>
                    <th scope="col">卡車</th>
                    <th scope="col">預估人流</th>
                    <th scope="col">觀光署預估人流</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in estimatePeopleList" :key="index" :class="tableCenterStyle">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.time }}</td>
                    <td>{{ item.areaName }}</td>
                    <td>{{ item.dateType }}</td>
                    <td>{{ item.motorbike }}</td>
                    <td>{{ item.car }}</td>
                    <td>{{ item.bus }}</td>
                    <td>{{ item.smallbus }}</td>
                    <td>{{ item.truck }}</td>
                    <td>{{removeNegativeAndDecimal(item.estimatePeopleCount)}}</td>
                    <td>{{removeNegativeAndDecimal(item.tourEstimatePeopleCount)}}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
    

  
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from 'vuex'
import VueApexCharts from "vue-apexcharts";
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import { postVehicleInTimeIntervalPerHour } from '../../api/eastCoastDataApi/ElkQuery/VehicleElk'
import exportCSV from '../../utils/exportCSV'
import ApexchartObject from '../../utils/apexchartObject/searchCar'


export default {
  components: { 
    apexchart: VueApexCharts,
  },
  data() {
    return {
      Const: CONST,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,
      estimatePeopleList: [],
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: -1,
      selectDeviceId: "-1",
      carTypeList: CONST.ELK_CAR_TYPE_ENUM,
      selectCarType: '',
      selectItem: null,
      ratioData: null,
      isWaitCCTVList: false,
      maxSelectTime: moment().startOf('m').toISOString(),
      chartData:[],
      chartSetting: ApexchartObject.monthReportOption,
    };
  },
  computed: {
    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },
    // ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),
    ...mapGetters("scenicArea", { scenicAreaList: "getMyScenicArea" }),

    ...mapGetters({ ScenicAreaCCTVList: 'getScenicAreaVehicleVideoCamera' }),
    ...mapState("passengerEstimateSetting", { estimateDataList: "allEstimateData" }),

    carFlowScenicArea() {
      return this.scenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CAR_FLOW))
    },
  },
  watch: {
    async selectScenicAreaId() {
      // this.isWaitCCTVList = true
      // await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', { id: this.selectScenicAreaId })
      // this.selectDeviceId = "-1"
      // this.isWaitCCTVList = false
    },
  },
  methods: {
    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
     },
    
    
    removeNegativeAndDecimal(value) {
      return value < 0 ? 0 : Math.floor(value*100)/100
    },

    async queryElk() {
      this.estimatePeopleList = await this.searchELK();
      this.updateTable()
    },

    async exportMothCSV() {
      const estimatePeopleList = await this.searchELK();

      const csvContent = [['時間', '風景區', '平/假日', '機車', '小型車', '大型車', '小巴', '卡車', '預估人流', '觀光署預估人流']]
      estimatePeopleList.forEach(item => {
        const row = []
        row.push(item.time)
        row.push(item.areaName)
        row.push(item.dateType)
        row.push(item.motorbike)
        row.push(item.car)
        row.push(item.bus)
        row.push(item.smallbus)
        row.push(item.truck)
        row.push(this.removeNegativeAndDecimal(item.estimatePeopleCount))
        row.push(this.removeNegativeAndDecimal(item.tourEstimatePeopleCount))
        csvContent.push(row)
      })
      const fileName = `統計_月報${moment(this.startTime).format('YYYY/MM/DD HH:mm')}.csv`
      exportCSV.genCSVFile(csvContent, fileName)
    },

    async searchELK() {
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return
      }

      const condition = {
        areas:[],
        sttime: moment(this.startTime).startOf('minute').format(),
        endtime: moment(this.endTime).startOf('minute').format(),
        interval: "day"
      }
      if(this.selectScenicAreaId === -1) {
        //全選
        this.carFlowScenicArea.forEach(e => {
          condition.areas.push(e.id)
        })
      }

      if(this.selectScenicAreaId > -1) {
        condition.areas.push(this.selectScenicAreaId)
      }

      const result = await postVehicleInTimeIntervalPerHour(condition)
      if(!result.success){
        return []
      }

      const internalCarTypeEnumList = this.$store.getters['passengerEstimateSetting/getInternalEstimateWeight']
      const externalCarTypeEnumList = this.$store.getters['passengerEstimateSetting/getExternalEstimateWeight']
      const holidayMap = this.$store.getters['holidaySetting/getHolidayMap']

      const total = {
        time: '統計',
        areaName: '',
        dateType: '',
        motorbike: 0,
        car: 0,
        bus: 0,
        smallbus: 0,
        truck: 0,
        estimatePeopleCount: 0,
        tourEstimatePeopleCount: 0
      }

      const dataList = result.data.map(e => {
        const data ={}
        data.areaName = e.areaName
        data.time = `${moment(e.dateTime).format('YYYY/MM/DD')}`
        data.motorbike = e.data.motorbike
        data.car = e.data.car
        data.bus = e.data.bus
        data.smallbus = e.data.smallbus
        data.truck = e.data.truck
        data.estimatePeopleCount = e.totalPeopleFlow
        data.tourEstimatePeopleCount = e.externalTotalPeopleFlow


        const date = moment(e.dateTime).startOf('day').format().split('+')[0]
        const weight = holidayMap.get(date) ? 'holidayWeight' : 'weight'
        data.dateType = holidayMap.get(date) ? CONST.ESTIMATE_DAT_TYPE.holiday : CONST.ESTIMATE_DAT_TYPE.ordinaryDay
        
        // data.estimatePeopleCount =  //東管處人流推估
        //   Math.round(
        //     (data.motorbike * internalCarTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.MOTO)[weight])+
        //     (data.car * internalCarTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.CAR)[weight]) +
        //     (data.bus * internalCarTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.BUS)[weight]) +
        //     (data.smallbus * internalCarTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.SMALLBUS)[weight]) +
        //     (data.truck * internalCarTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.TRUCK)[weight])
        //   )

        // data.tourEstimatePeopleCount = //觀光署人流推估
        //   Math.round(
        //     (data.motorbike * externalCarTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.MOTO)[weight]) +
        //     (data.car * externalCarTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.CAR)[weight]) +
        //     (data.bus * externalCarTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.BUS)[weight]) +
        //     (data.smallbus * externalCarTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.SMALLBUS)[weight]) +
        //     (data.truck * externalCarTypeEnumList.find(e => e.enumType === CONST.CAR_TYPE.TRUCK)[weight])
        //   )


        total.motorbike = total.motorbike + data.motorbike
        total.car = total.car + data.car
        total.bus = total.bus + data.bus
        total.smallbus = total.smallbus + data.smallbus
        total.truck = total.truck + data.truck
        total.estimatePeopleCount = total.estimatePeopleCount + data.estimatePeopleCount 
        total.tourEstimatePeopleCount = total.tourEstimatePeopleCount + data.tourEstimatePeopleCount 
        
        return data
      })
      total.estimatePeopleCount = Math.round(total.estimatePeopleCount);
      total.tourEstimatePeopleCount = Math.round(total.tourEstimatePeopleCount);

      dataList.push(total)
      return dataList
    },

    initTable: function () {
      this.table = $("#monthReport").DataTable({
        aoColumns: [
          ...new Array($("#monthReport th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url :'/json/dataTableZHTW.json'
        },
        "pageLength": 25
      });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy()
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    }
  },
  mounted() {
    this.updateTable()
  },
}
</script>

<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td, tr > th {width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */
</style>
